import { environment } from '../../environments/environment-wrapper';
import { HasMinMax } from '../components/forms/min-max-slider/min-max-slider.component';
import { HttpParams } from '@angular/common/http';
import { Pagination } from './pagination';
import { SearchFiltersParams } from './search-filters-params';
import { truncate } from 'lodash';

export class Helper {

  public static snakeToCamelcase(txt: string): string {
    return txt.replace(/(_\w)/g, m => m[1].toUpperCase());
  }

  public static toMagnitudes(value, isFixedNumber: boolean = false) {
    if (value >= 1000000) return (isFixedNumber ? (value / 1000000) : (value / 1000000).toFixed(0)) + 'M';
    if (value >= 1000) return (isFixedNumber ? (value / 1000) : (value / 1000)) + 'K';
    return value.toString().trim();
  }

  public static toDollarMagnitudes(value): string {
    if (value >= 1000000) return '$' + (value / 1000000).toFixed(1) + 'M';
    if (value >= 1000) return '$' + (value / 1000) + 'K';
    return '$' + value.toString().trim();
  }

  // TODO: blend this with above
  public static formatPrice(price: number, minPriceToBeRounded: number = 1000): string {
    let output: string;

    if (price >= 1000000) {
      let number = price / 1000000;
      number = +number.toFixed(2);
      output = number.toString() + 'M';
    }
    else if (price >= minPriceToBeRounded) {
      let number = price / 1000;
      number = +number.toFixed(0);
      output = number.toString() + 'K';
    }
    else output = price.toFixed(2).toString();

    return output.trim();
  }

  public static formatPhoneNumber(s): string {
    const s2 = ('' + s).replace(/\D/g, '');
    const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return (!m) ? null : m[1] + '-' + m[2] + '-' + m[3];
  }

  public static decimalToPercent(n: number | string): number {
    if (isNaN(+n)) return 0;
    return +n * 100;
  }

  public static numberWithCommas(x: number): string {
    const parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  public static compareWithHasMinMax(item1: HasMinMax, item2: HasMinMax): boolean {
    if (
      (!item1 && !item2) || (!item1 && item2) || (item1 && !item2) ||
      (Object.keys(item1).length !== Object.keys(item2).length)) return false;
    return item1.min === item2.min && item1.max === item2.max
  }


  public static setSearchParams(pagination: Pagination, searchParams: SearchFiltersParams): HttpParams {
    let params = new HttpParams()
      .set('from', pagination.offset.toString())
      .set('size', pagination.limit.toString());

    if (searchParams) {
      params = params.set('text', searchParams.text);
      if (searchParams.randomSeed) params = params.set('randomSeed', searchParams.randomSeed);
      if (searchParams.features) {
        if (searchParams.features.language) params = params.set('language', searchParams.features.language);
        if (searchParams.features.specialty) params = params.set('specialty', searchParams.features.specialty);
        if (searchParams.features.serviceArea) params = params.set('serviceArea', searchParams.features.serviceArea);
        if (searchParams.features.civicActivity) {
          if (searchParams.features.civicActivity.canadianBreastCancerFoundation) params = params.append('civicActivities', 'Canadian Breast Cancer Foundation');
          if (searchParams.features.civicActivity.childrensMiracleNetwork) params = params.append('civicActivities', 'Children\'s Miracle Network');
        }
        if (searchParams.features.propertyType) {
          if (searchParams.features.propertyType.indexOf('/') >= 0) {
            params = params.append('propertyTypes', 'Residential');
            params = params.append('propertyTypes', 'Commercial');
          } else {
            params = params.set('propertyTypes', searchParams.features.propertyType);
          }
        }
      }
    }
    return params;
  }

  /**
   * Takes in a static resource location (ie /assets/favAgent.svg) and inserts an S3 bucket location if defined in the environment.
   * So it could return https://dev-dotca.remaxintegracdn.net/assets/favAgent.svg
   * @static
   * @param {string} resourcePath The static resource path to translate
   * @returns The static resource path including any staticResourceRoot that should be inserted at the start of the path.
   * @memberof Helper
   */
  public static getStaticPathForResource(resourcePath: string) {
    if (!resourcePath) {
      return resourcePath;
    }

    if (resourcePath.charAt(0) === '/') {
      return environment.staticResourceRoot + resourcePath.substr(1, resourcePath.length - 1);
    }

    if (resourcePath.startsWith('http')) {
      return resourcePath;
    }

    return environment.staticResourceRoot + resourcePath;
  }

  public static getZoomLevel(types: Array<string>): number {
    if (types.indexOf('country') >= 0) {
      return 5;
    }

    if (types.indexOf('administrative_area_level_1') >= 0) {
      return 6;
    }

    if (types.indexOf('locality') >= 0) {
      return 12;
    }

    if (types.indexOf('street_address') >= 0 || types.indexOf('premise') >= 0) {
      return 18;
    }

    if (types.indexOf('establishment') >= 0 || types.indexOf('point_of_interest') >= 0) {
      return 17;
    }

    return 14;
  }

  /*
  Reduce length of text to 'length' number of characters and append '...' at the end
   */
  static reduceText(character: string, length:number) {
    return truncate(character, {
      'length': length,
      'separator': ' '
    });
  }
}
